import { Notice } from '@teliaee/design-system';
import config from '../../Config';
import React from 'react';
import useStores from '../../stores/UseStores';

type Props = {
  method: 'sid' | 'mid';
};

export const TestAuthWarning = ({ method }: Props) => {
  const {
    translateStore: { translate },
  } = useStores();

  const isTestEnv = config.env === 'test';

  if (!isTestEnv) {
    return null;
  }

  return <Notice type="attention">{translate(`${method}.testAuthWarning`)}</Notice>;
};
